import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiParameters } from 'src/app/configs/api.params';
@Injectable({
  providedIn: 'root',
})
export class FrameService {
  public apiEndPoint = apiParameters.url;
  // public apiParam = '/users/7';

  constructor(private httpClient: HttpClient) {}

  getFrames(): Observable<any> {
    const url = apiParameters.url + '/frames';
    return this.httpClient.get(url);
  }

  addFrame(body): Observable<any> {
    const url = apiParameters.url + '/frames';
    return this.httpClient.post(url, body);
  }

  deleteFrame(frameId: string): Observable<any> {
    console.log(frameId)
    const url = apiParameters.url + '/frames/' + frameId;
    return this.httpClient.delete(url);
  }

  editFrame(frameId: string, body): Observable<any> {
    const url = apiParameters.url + '/frames/' + frameId;
    return this.httpClient.patch(url, body);
  }

  addFrameFile(frameId: string, body): Observable<any> {
    const url = apiParameters.url + '/frames/' + frameId + '/files';
    return this.httpClient.post(url, body);
  }

  deleteFrameFile(frameId: string, fileId: string): Observable<any> {
    const url = apiParameters.url + '/frames/' + frameId + '/files/' + fileId;
    return this.httpClient.delete(url);
  }

  createFrameByCustomer(customerId: string, body): Observable<any> {
    const url = apiParameters.url + '/customers/' + customerId + '/frames';
    return this.httpClient.post(url, body);
  }

  addFrameToCustomer(customerId: string, frameId: string): Observable<any> {
    const url =
      apiParameters.url +
      '/customers/' +
      customerId +
      '/frames/' +
      frameId +
      '/owner';
    return this.httpClient.post(url, {});
  }

  getCustomerFrames(customerId: string): Observable<any> {
    const url = apiParameters.url + '/customers/' + customerId + '/frames';
    return this.httpClient.get(url);
  }

  deleteFrameFromCustomer(customerId: string, frameId: string): Observable<any> {
    const url = apiParameters.url + '/customers/' + customerId +'/frames/' + frameId + '/owner';
    return this.httpClient.delete(url);
  }

  createFrameByClient(clientId: string, body): Observable<any> {
    const url = apiParameters.url + '/clients/' + clientId + '/frames';
    return this.httpClient.post(url, body);
  }

  addFrameToClient(clientId: string, frameId: string): Observable<any> {
    const url =
      apiParameters.url +
      '/clients/' +
      clientId +
      '/frames/' +
      frameId +
      '/owner';
    return this.httpClient.post(url, {});
  }

  getClientFrames(clientId: string): Observable<any> {
    const url = apiParameters.url + '/clients/' + clientId + '/frames';
    return this.httpClient.get(url);
  }

  deleteFrameFromClient(clientId: string, frameId: string): Observable<any> {
    const url = apiParameters.url + '/clients/' + clientId +'/frames/' + frameId + '/owner';
    return this.httpClient.delete(url);
  }


  /**
   * This method gets the user list of frames
   * @param userId - user id
   * @returns user frames
   */
  getUserFrames(userId: string): Observable<any> {
    const url = apiParameters.url + '/users/' + userId + '/frames';
    return this.httpClient.get(url);
  }

  /**
   * Create frame by user
   * @param userId - user id
   * @param body - form data for frame e.g. {"name": "test", "configuration": { "width": 1920,"height": 1440, "images": [{"x": 0,"y": 0,"key": "image_1","width": 1920,"height": 1440}]}}
   * @returns user frame
   */
  createFrameByUser(userId: string, body): Observable<any> {
    const url = apiParameters.url + '/users/' + userId + '/frames';
    return this.httpClient.post(url, body);
  }

  addFrameToUser(userId: string, frameId: string): Observable<any> {
    const url =
      apiParameters.url +
      '/users/' +
      userId +
      '/frames/' +
      frameId +
      '/owner';
    return this.httpClient.post(url, {});
  }

  /**
   * Edit frame
   * @param userId - user id
   * @param frameId - frame id
   * @param body - form data for frame e.g. {"name": "testedit", "configuration": { "width": 1920,"height": 1440, "images": [{"x": 0,"y": 0,"key": "image_1","width": 1920,"height": 1440}]}}
   * @returns frame
   */
  editUserFrame(userId: string, frameId: string, body): Observable<any> {
    const url = apiParameters.url + '/users/' + userId + '/frames/' + frameId;
    return this.httpClient.patch(url, body);
  }

  deleteFrameFromUser(userId: string, frameId: string): Observable<any> {
    const url =
      apiParameters.url + '/users/' + userId + '/frames/' + frameId + '/owner';
    return this.httpClient.delete(url);
  }

  addFrameFileUser(userId: string, frameId: string, body): Observable<any> {
    const url =
      apiParameters.url + '/users/' + userId + '/frames/' + frameId + '/files';
    return this.httpClient.post(url, body);
  }

  deleteFrameFileUser(
    userId: string,
    frameId: string,
    fileId: string
  ): Observable<any> {
    const url =
      apiParameters.url +
      '/users/' +
      userId +
      '/frames/' +
      frameId +
      '/files/' +
      fileId;
    return this.httpClient.delete(url);
  }

  /**
   * Assigns frame to a user preset
   * @param userId  - user id
   * @param frameId  - frame id
   * @param presetId - preset id
   * @param profileId - selected settings profile id
   * @returns frame
   */
  assignFrameToPreset(
    userId,
    frameId,
    presetId,
    profileId?: string
  ): Observable<any> {
    let searchParams = new HttpParams();

    if (profileId && profileId !== '') {
      searchParams = searchParams.append('profileId', profileId);
    }

    const httpOptions = {
      headers: new HttpHeaders({}),
      params: searchParams,
    };

    const body = {
      presetId,
    };

    const url =
      apiParameters.url +
      '/users/' +
      userId +
      '/frames/' +
      frameId +
      '/presets';
    return this.httpClient.post(url, body, httpOptions);
  }

  /**
   * Deletes assigned frame
   * @param userId - user id
   * @param frameId - frame id
   * @param presetId - preset id
   * @param profileId - selected settings profile id
   * @returns frame
   */
  deleteAssignedFrame(
    userId,
    frameId,
    presetId,
    profileId?: string
  ): Observable<any> {
    let searchParams = new HttpParams();

    if (profileId && profileId !== '') {
      searchParams = searchParams.append('profileId', profileId);
    }

    const httpOptions = {
      headers: new HttpHeaders({}),
      params: searchParams,
    };

    const url =
      apiParameters.url +
      '/users/' +
      userId +
      '/frames/' +
      frameId +
      '/presets/' +
      presetId;
    return this.httpClient.delete(url, httpOptions);
  }

  /**
   * Activates the user frame at the target position
   * @param userId - user id
   * @param presetId - preset id
   * @param targetId - target id
   * @param useFrame - if true selected target
   * @param profileId - selected settings profile id
   * @returns target position
   */
  activateFrameOnTarget(
    userId,
    presetId,
    targetId,
    useFrame,
    profileId?: string
  ): Observable<any> {
    let searchParams = new HttpParams();

    if (profileId && profileId !== '') {
      searchParams = searchParams.append('profileId', profileId);
    }

    const httpOptions = {
      headers: new HttpHeaders({}),
      params: searchParams,
    };

    const body = {
      useFrame,
    };

    const url =
      apiParameters.url +
      '/users/' +
      userId +
      '/presets/' +
      presetId +
      '/targets/' +
      targetId;
    return this.httpClient.patch(url, body, httpOptions);
  }

  updateTarget(
    userId,
    presetId,
    targetId,
    body,
    profileId?: string
  ): Observable<any> {
    let searchParams = new HttpParams();

    if (profileId && profileId !== '') {
      searchParams = searchParams.append('profileId', profileId);
    }

    const httpOptions = {
      headers: new HttpHeaders({}),
      params: searchParams,
    };

    const url =
      apiParameters.url +
      '/users/' +
      userId +
      '/presets/' +
      presetId +
      '/targets/' +
      targetId;
    return this.httpClient.patch(url, body, httpOptions);
  }
}
